import React, { useEffect, useRef } from "react";
import "../assets/styles/CTA.css";

function useReveal(threshold = 0.2) {
  const ref = useRef(null);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          el.classList.add("visible");
          observer.disconnect();
        }
      },
      { threshold },
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, [threshold]);
  return ref;
}

function CTA() {
  const eyebrowRef = useReveal();
  const titleRef = useReveal();
  const subtitleRef = useReveal();
  const buttonsRef = useReveal();

  return (
    <section id="book" className="cta-section">
      <div className="cta-bg" aria-hidden="true" />
      <div className="cta-overlay" aria-hidden="true" />

      <div className="cta-inner">
        <div className="container-fluid px-4 px-lg-5">
          <div
            ref={eyebrowRef}
            className="cta-eyebrow cta-reveal cta-reveal-d1"
          >
            Limited Availability
          </div>

          <h2 ref={titleRef} className="cta-title cta-reveal cta-reveal-d2">
            Your Perfect
            <br />
            <em>Escape</em> Awaits
          </h2>

          <p
            ref={subtitleRef}
            className="cta-subtitle cta-reveal cta-reveal-d3"
          >
            Reserve your stay and wake up to birdsong, golden light, and the
            stillness that only nature can offer.
          </p>

          <div
            ref={buttonsRef}
            className="cta-buttons cta-reveal cta-reveal-d4"
          >
            <a href="#contact" className="cta-btn-primary">
              Book Your Stay
            </a>
            <a href="#features" className="cta-btn-ghost">
              View Features
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}

export default CTA;
